module.exports = __webpack_public_path__ + "img/supplier.5aa80b1f.png";